import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { WithManagedFocuser } from '@bingads-webui-react/hoc-with-managed-focuser';
import { submitEvent } from '@bingads-webui-universal/accessibility-helper';
import './month-calender.less';

class YearItemInternal extends React.PureComponent {
  onFocusHandler = () => {
    this.props.focusItemCallback(this.props.year);
  }

  handleYearSelect = () => {
    const {
      onSelectYear,
      year,
      isYearInRange,
    } = this.props;
    if (isYearInRange(year)) {
      onSelectYear(year);
    }
  }
  render() {
    const {
      yearIdx,
      year,
      isYearInRange,
      focusableRef,
      focusThis,
    } = this.props;

    return (
      <td
        key={yearIdx}
        ref={focusableRef}
        role="gridcell"
        className={classNames([isYearInRange(year) ? '' : 'disabled', `yearItem-${year}`])}
        onKeyDown={event => submitEvent(this.handleYearSelect)({ keyCode: event.which })}
        tabIndex={yearIdx === 0 ? '0' : '-1'}
        onClick={focusThis && this.handleYearSelect}
        onFocus={this.onFocusHandler}
      >
        <div
          className="day"
          role="gridcell"
        >
          <span aria-hidden="true">{year}</span>
        </div>
      </td>
    );
  }
}

YearItemInternal.propTypes = {
  yearIdx: PropTypes.number.isRequired,
  year: PropTypes.number.isRequired,
  onSelectYear: PropTypes.func.isRequired,
  isYearInRange: PropTypes.func.isRequired,
  focusThis: PropTypes.func.isRequired,
  focusableRef: PropTypes.func,
  focusItemCallback: PropTypes.func.isRequired,
};

YearItemInternal.defaultProps = {
  focusableRef: null,
};

export const YearItem = WithManagedFocuser(YearItemInternal);
